/* eslint-disable react/display-name */
import clsx from 'clsx'
import { forwardRef } from 'react'
import HamburgerIcon from '../../../components/icons/HamburgerIcon'
import LogoutButton from '../../components/LogoutButton'
import Menus from '../../components/Menus'

type IProps = {
  show: boolean
  onClickHamburgerMenu?: () => void
  onClickHamburgerIcon?: () => void
}
type Ref = HTMLDivElement

const HamburgerMenu = forwardRef<Ref, IProps>(
  ({ show, onClickHamburgerMenu, onClickHamburgerIcon }, ref) => {
    return (
      <div
        className={clsx(
          'flex flex-col justify-between absolute w-56 p-4 -top-5 h-screen bg-white shadow-[-4px_0_16px_4px_rgba(0,0,0,0.05)] overflow-y-auto scrollbar',
          show ? '-right-4' : 'left-56 ',
        )}
        ref={ref}
        onClick={onClickHamburgerMenu}
      >
        <div>
          <div className='flex justify-end '>
            <HamburgerIcon classes='rotate-180' handleClick={onClickHamburgerIcon} />
          </div>
          <Menus classes='mt-6' />
        </div>
        <LogoutButton />
      </div>
    )
  },
)

export default HamburgerMenu
